import {
  RR_ADMIN_PROFILE_TYPES,
  R4U_ADMIN_PROFILE_TYPES,
  CORP_ADMIN_MEMBER_TYPE,
  LUSSO_ADMIN_MEMBER_TYPE
} from '@/infrastructure/Configuration'
import { adminType, programType, R4U_ADMIN_MEMBER_TYPES } from '@/domain/MyAccount'
import {
  hasCorporateMemberType,
  hasLussoMemberType,
  hasMemberType,
  hasR4UMemberType,
  normalizeMemberTypes
} from '@/domain/memberTypes'

const matchesProfileType = (customer, adminProfileTypes) =>
  adminProfileTypes.some(type => customer?.profileType?.includes(type))

export const isCorpAdmin = (customer, isLussoFFEnabled) => {
  if (isLussoFFEnabled) {
    return hasCorporateMemberType(customer) && hasMemberType(customer, CORP_ADMIN_MEMBER_TYPE)
  }
  return matchesProfileType(customer, RR_ADMIN_PROFILE_TYPES)
}

export const isR4uAdmin = customer => {
  if (normalizeMemberTypes(customer).length > 0) {
    return hasR4UMemberType(customer) && hasMemberType(customer, R4U_ADMIN_MEMBER_TYPES)
  }
  return matchesProfileType(customer, R4U_ADMIN_PROFILE_TYPES)
}

export const isLussoAdmin = (customer, isLussoFFEnabled) => {
  if (!isLussoFFEnabled) {
    return false
  }
  return hasLussoMemberType(customer) && hasMemberType(customer, LUSSO_ADMIN_MEMBER_TYPE)
}

export const resolveAdminType = (customer, isLussoFFEnabled) => {
  const corp = isCorpAdmin(customer, isLussoFFEnabled)
  const r4u = isR4uAdmin(customer)
  const lusso = isLussoAdmin(customer, isLussoFFEnabled)

  if (corp && (r4u || lusso)) {
    return adminType.HYBRID
  }
  if (corp) {
    return adminType.CORPORATE
  }
  if (r4u) {
    return adminType.R4U
  }
  if (lusso) {
    return adminType.LUSSO
  }
  return ''
}

// For a hybrid admin case, the second program option (R4U or LUSSO) in the invitation step 0
export const getSecondProgram = (customer, isLussoFFEnabled) =>
  isLussoAdmin(customer, isLussoFFEnabled) ? programType.LUSSO : programType.R4U
